import { render, staticRenderFns } from "./OrdersRecieved.vue?vue&type=template&id=39f37ee5&"
import script from "./OrdersRecieved.vue?vue&type=script&lang=js&"
export * from "./OrdersRecieved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports